// Event Date and Venue
export const EVENT_DATE = new Date('2025-12-20T09:00:00');
export const VENUE_NAME = "Akademi Laut Malaysia (ALAM) Melaka";
export const VENUE_ADDRESS = "Jalan Kuala Sungai Baru / Kuala Linggi, Batu,\n78200 Kuala Sungai Baru, Melaka";
export const STORAGE_KEY = 'alumni_homecoming_rsvps';
export const YOUR_GOOGLE_APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbweP1pmdnFCto6V79OppOqbuZ6NGdDKQmzP3OBnvrWrxlIOJleC72IDyn_1utr1fj4vrQ/exec";

// Event Information
export const EVENT_NAME = "ALAM Alumni Homecoming 2025";
export const EVENT_HASHTAG = "#LiveTheGlory";
export const GREETING = "Good Day and Salam Sejahtera!";
export const ORGANIZER = "Akademi Laut Malaysia";

// Event Details
export const EVENT_DATE_DISPLAY = "20 December 2025";
export const EVENT_DAY = "Saturday";
export const RSVP_DEADLINE = "14th December 2025";
export const DRESS_CODE = "Smart Casual";
export const TOTAL_PAX = "400 pax";

export const CONTACTS = [
  { name: "Rafi'", phone: "+601116516433", role: "Event Guest Support", whatsapp: "https://wa.link/9tud48" }
];

// Session Information
export const SESSION_OPTIONS = [
  "Morning Session (9am-12pm)",
  "Afternoon Session (3pm-6pm)",
  "Both"
];

// Program Details
export const MORNING_SESSION = {
  time: "9.00 a.m. - 12.00 p.m.",
  activities: ["Football", "Badminton", "Pickleball"]
};

export const AFTERNOON_SESSION = {
  time: "3.00 p.m. - 6.00 p.m.",
  activities: ["Hi-Tea"]
};

// Payment Information
export const PAYMENT_GATEWAY_URL = "https://app.senangpay.my/payment/176412499671"; // Replace with actual payment gateway URL
export const PAYMENT_REQUIRED_SESSIONS = [
  "Afternoon Session (3pm-6pm)",
  "Both"
];
